var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExameAnatomia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-anatomia{fill:none;}.b-anatomia{isolation:isolate;clip-path:url(#a);}.c-anatomia{fill:#d7e5fc;}.d-anatomia{fill:#454f63;}\n\t\t"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a-anatomia",
    x: 2,
    y: 2,
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b-anatomia",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.248 -468.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c-anatomia",
    d: "M31.96,21a10.96,10.96,0,1,0,10.96,10.96A10.96,10.96,0,0,0,31.96,21Z",
    transform: "translate(31.439 466.438)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.119 473.239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.083 20.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M276.549,382a.549.549,0,1,0,.549.549A.549.549,0,0,0,276.549,382Z",
    transform: "translate(-276 -382.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M76.351,23.178l-.45-1.35a7.622,7.622,0,0,0,2.068-5.241A7.757,7.757,0,0,0,72.41,9.158l1.346-2.332a.549.549,0,0,0-.2-.75L73.079,5.8l.549-.951.476.275a.549.549,0,0,0,.75-.2l1.1-1.9a.549.549,0,0,0-.2-.75l-3.8-2.2a.549.549,0,0,0-.75.2l-1.1,1.9a.549.549,0,0,0,.2.75l.476.275-.549.951-.476-.275a.549.549,0,0,0-.75.2l-4.119,7.135-.476-.275a.549.549,0,0,0-.75.2l-1.1,1.9a.549.549,0,0,0,.2.75l5.707,3.3a.549.549,0,0,0,.75-.2l1.1-1.9a.549.549,0,0,0-.2-.75l-.476-.275.406-.7a3.316,3.316,0,0,1,3.532,3.328,3.26,3.26,0,0,1-.44,1.647,5.12,5.12,0,0,0-5.474.55H62.3A2.732,2.732,0,0,0,59.844,20.3l-.491.983a.549.549,0,0,0,.491.795h5.829l-.366,1.1H57.648A1.65,1.65,0,0,0,56,24.825v2.746a.549.549,0,0,0,.549.549h20.87a.549.549,0,0,0,.549-.549V24.825A1.649,1.649,0,0,0,76.351,23.178ZM71.873,1.3l2.854,1.648-.549.951L71.324,2.251Zm-.147,2.452.951.549-.549.951L71.177,4.7ZM68.539,15.863l-4.756-2.746.549-.951,4.28,2.471h0l.475.274Zm.147-2.452-2.854-1.648L69.676,5.1l2.136,1.233-.156-.09.873.5Zm1.985-1.242,1.171-2.028a6.616,6.616,0,0,1,5.028,6.445,6.527,6.527,0,0,1-1.4,4.058,5.15,5.15,0,0,0-1.413-1.812,4.346,4.346,0,0,0,.616-2.246A4.424,4.424,0,0,0,70.671,12.17Zm.158,6.614a4.023,4.023,0,0,1,3.816,2.75l.548,1.643H66.465l.548-1.643A4.025,4.025,0,0,1,70.829,18.783Zm-10.1,2.2a1.708,1.708,0,0,1,1.568-1.1h4.325a5.17,5.17,0,0,0-.581,1.1ZM76.87,27.022H57.1v-2.2a.55.55,0,0,1,.549-.549H76.321a.55.55,0,0,1,.549.549Z",
    transform: "translate(-56 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M345.137,116.1l.091.053Z",
    transform: "translate(-329.257 -109.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M345.071,116.065l0,0Z",
    transform: "translate(-329.195 -109.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M343.919,115.4l.005,0Z",
    transform: "translate(-328.106 -109.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M344.016,115.456l.058.033Z",
    transform: "translate(-328.198 -109.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M346.795,117.06l.015.009Z",
    transform: "translate(-330.824 -110.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M350.946,119.457l0,0Z",
    transform: "translate(-334.747 -112.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M350.7,119.312l.014.008Z",
    transform: "translate(-334.51 -112.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M351.033,119.507Z",
    transform: "translate(-334.829 -112.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M349.3,118.5l.012.007Z",
    transform: "translate(-333.187 -111.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M349.511,118.628l.065.038Z",
    transform: "translate(-333.391 -112.113)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M348.971,118.317l.018.01Z",
    transform: "translate(-332.881 -111.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M347.072,117.22l.1.06Z",
    transform: "translate(-331.086 -110.782)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.28 20.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-anatomia",
    d: "M318.746,382h-2.2a.549.549,0,1,0,0,1.1h2.2a.549.549,0,1,0,0-1.1Z",
    transform: "translate(-316 -382.001)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExameAnatomia);
export default __webpack_public_path__ + "static/media/exame-anatomia.182dc03f.svg";
export { ForwardRef as ReactComponent };